<div class="previsions-container">
    <div class="header">
        <span>{{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_TITLE' | translate }}</span>
        <!-- <button [pTooltip]="tooltipContent" tooltipEvent="focus" class="info-button">?</button> -->
        <!-- <ng-template #tooltipContent>
            <div>
                <span> {{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_TOOLTIP' | translate }} </span>
            </div>
        </ng-template> -->
    </div>
    <div class="actions">
        <div class="controls">
            <div class="period-selection">
                <button [ngClass]="{ 'active': selectedPeriodDays === 15 }" class="period-btn" type="button" (click)="filterDataByPeriod(15, $event)">{{ 'HEADBAND.MODELE.MODAL.GRAPH.FIFTEEN' | translate }}</button>
                <button [ngClass]="{ 'active': selectedPeriodDays === 30 }" class="period-btn" type="button" (click)="filterDataByPeriod(30, $event)">{{ 'HEADBAND.MODELE.MODAL.GRAPH.THIRTY' | translate }}</button>
                <button [ngClass]="{ 'active': selectedPeriodDays === 365 }" class="period-btn" type="button" (click)="filterDataByPeriod(365, $event)">{{ currentYear }}</button>
                <button [ngClass]="{ 'active': selectedPeriodDays === 365*10 }" class="period-btn" type="button" (click)="filterDataByPeriod(365 * 10, $event)">{{ 'HEADBAND.MODELE.MODAL.GRAPH.TEN_YEAR' | translate }}</button>
            </div>
        <!-- <button pButton type="button" (click)="op.toggle($event)" class="curve-btn">
            <span class="color-circle-gradient"></span>
            {{ 'ADMIN.MODEL.COMPUTE.CURVE' | translate }}
            <i class="pi" [ngClass]="{'pi-chevron-down': !op.overlayVisible, 'pi-chevron-up': op.overlayVisible}"></i>
        </button> -->
        <!-- <p-overlayPanel #op [dismissable]="true">
            <div class="predictions">
            <span class="label-predi">{{ 'HEADBAND.MODELE.MODAL.GRAPH.LEGENDE_DROP' | translate }}</span>
            <ul>
                <li *ngFor="let legende of legendeItems">
                <input type="checkbox" [(ngModel)]="legende.selected" (change)="toggleDataset(legende.label)" />
                <span class="color-circle" [ngClass]="getPredictionClass(legende.label)" [ngStyle]="{'background-color': getDynamicColor(legende.label)}"></span>
                {{ legende.label }}
                </li>
            </ul>
            <span class="label-predi">{{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_DROP' | translate }}</span>
            <ul>
                <li *ngFor="let prediction of predictionItems; trackBy: trackByLabel">
                <input type="checkbox" [(ngModel)]="prediction.selected" (change)="toggleDataset(prediction.label)" />
                <span class="color-circle" [ngClass]="getPredictionClass(prediction.label)"></span>
                {{ prediction.label }}
                </li>
            </ul>
            </div>
        </p-overlayPanel>
        <p-floatLabel *ngIf="hasScenario">
            <p-dropdown 
            [options]="availableScenarios" 
            [(ngModel)]="selectedScenario"
            optionLabel="labelScenario"
            (onChange)="onChangeScenario($event)"
            class="custom-dropdown curve-btn"
            ></p-dropdown>
            <label>{{ 'HEADBAND.MODELE.MODAL.GRAPH.SCENARIO_PREV' | translate }}</label>
        </p-floatLabel> -->
        
        <!-- <button pButton type="button" (click)="toggleIps()" class="curve-btn" *ngIf="isPremium">
            {{ ipsLabel }}
        </button> -->
        </div>
        <div>
        <p-button icon="pi pi-ellipsis-v" [rounded]="true" (click)="onGraphActions($event)" [text]="true"></p-button>
        <p-overlayPanel #graphActionsTemplate>
            <div class="btn-container">
                <div class="btn-content">
                    <a href="https://ades.eaufrance.fr/Fiche/PtEau?Code={{identifier}}" target="_blank">
                    {{ 'HEADBAND.MODELE.MODAL.GRAPH.LINK-ADES' | translate }}
                    </a>
                </div>
                <div class="btn-content">
                <a (click)="exportChart()">
                    {{ 'HEADBAND.MODELE.MODAL.GRAPH.LINK-PNG' | translate }}
                </a>
                </div>
                <div class="btn-content" *ngIf="isPremium">
                <a (click)="exportCSV()">
                    {{ 'HEADBAND.MODELE.MODAL.GRAPH.LINK-VEOLIA' | translate }}
                </a>
                </div>
            </div>
        </p-overlayPanel>
        </div>
    </div>

    <!-- <div class="chart-toolbar">
        <p-button [icon]="modeZoom ? 'pi pi-arrows-alt' : 'pi pi-search'" severity="secondary" (onClick)="setModeZoom()" />
        <p-button icon="pi pi-refresh" severity="secondary" (onClick)="resetZoomBtn()" />
    </div> -->

    <!-- <div class="ips-legende" *ngIf="isPremium && ipsShow">
        <div *ngFor="let ips of ipsItems;">
        <p-tag class="legende-tag" *ngIf="ips.showLegende" [style]="{ background: '#e0e0e0', color: 'black' }">
            <span class="color-circle" [ngClass]="getPredictionClass(ips.label)"></span>
            <span class="text-base">
                {{ ips.label.replace('IPS - ', '') }}
            </span>
        </p-tag>
        </div>
    </div> -->

    <div class="chart-container" style="position: relative;">
        <p-button class="chart-toolbar" icon="pi pi-cog" [raised]="true" (onClick)="openCourbesOptions()" />
        <div *ngIf="loading" class="loading-content">
            <fa-icon [icon]="faSpinner"></fa-icon>
            <div>{{ 'HEADBAND.MODELE.MODAL.LOADING_MODAL' | translate }}</div>
        </div>
        <canvas id="chartForecastModel"></canvas>
    </div>

    <p-button *ngIf="isPremium" class="btn-select-month" label="{{ selectedMonths?.label }}" (onClick)="openSelectMonths()" />
    <p-sidebar [visible]="showMonths" position="bottom" (onHide)="closeSelectMonths()" class="select-months" [style]="{ width: '100%' }" [modal]="false" *ngIf="isPremium">
        <ng-template pTemplate="header">
            <div class="title-modal">
                <h3>{{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_TITLE' | translate }}</h3>
            </div>
        </ng-template>
        <div class="btn-container">
            <p-listbox 
                [options]="monthItems" 
                [(ngModel)]="selectedMonths" 
                optionLabel="label"
                [style]="{'width':'100%'}" 
                [listStyle]="{'max-height': '100%'}"
                (onChange)="onChange($event)" />
        </div>
    </p-sidebar>

    <p-sidebar [visible]="showCourbesOptions" position="bottom" (onHide)="closeCourbesOptions()" class="courbes-options" [style]="{ width: '100%' }" [modal]="false">
        <ng-template pTemplate="header">
            <div class="title-modal">
                <h3><i class="pi pi-cog"></i> {{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_TITLE' | translate }}</h3>
            </div>
        </ng-template>
        <div class="title-courbes" (click)="closeCourbesOptions()">
            <span>{{ 'ADMIN.MODEL.COMPUTE.CURVE' | translate }}</span><i class="pi pi-chevron-up"></i>
        </div>
        <div class="btn-container">
            <div class="predictions">
                <span class="label-predi">{{ 'ADMIN.MODEL.COMPUTE.LEGEND' | translate }}</span>
                <ul>
                    <li *ngFor="let legende of legendeItems" (click)="toggleCheckbox(legende, $event)">
                    <input type="checkbox" [(ngModel)]="legende.selected" (click)="handleCheckboxClick(legende, $event)" />
                    <span class="color-circle" [ngClass]="getPredictionClass(legende.label)" [ngStyle]="{'background-color': getDynamicColor(legende.label)}"></span>
                    {{ legende.label }}
                    </li>
                </ul>
                <span class="label-predi">{{ 'HEADBAND.MODELE.MODAL.GRAPH.FORECAST_DROP' | translate }}</span>
                <ul>
                    <li *ngFor="let prediction of predictionItems; trackBy: trackByLabel" (click)="toggleCheckbox(prediction, $event)">
                    <input type="checkbox" [(ngModel)]="prediction.selected" (click)="handleCheckboxClick(prediction, $event)" />
                    <span class="color-circle" [ngClass]="getPredictionClass(prediction.label)"></span>
                    {{ prediction.label }}
                    </li>
                </ul>
            </div>
        </div>
    </p-sidebar>

</div>